<template>
  <div id="uploader">
    <div class="file-managed-list" v-if="showUploadList">
      <div class="ivu-upload-list-file" style="width: 240px;" v-if="uploadedList" v-for="item in uploadedList" :key="item.id">
        <div style="cursor: pointer; width: 100%; position: relative; text-align: center;" @click="handleImgPreview(item.currentMedia.url)">
          <img v-if="item && item.currentMedia" :src="item.currentMedia.url" style="width: 200px;" alt="">
          <Icon type="ios-close" class="ivu-upload-list-remove" style="position: absolute; top: 0;" @click.stop="handleRemove(item)"></Icon>
        </div>
        <template>
          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
      </div>
    </div>
    <Modal :title="$t('product.attachments.img_title')" v-model="imgVisible" footer-hide transfer>
      <img :src="imgSrc" style="width: 100%" alt="">
    </Modal>
    <Upload v-show="showUploader" ref="uploader"
            :type="type"
            :default-file-list="defaultFileList"
            :action="target"
            :disabled="disabled || disableUpload"
            :accept="accept"
            :format="format"
            :data="data"
            :multiple="multiple"
            :headers="headers"
            :before-upload="handleBeforeUpload"
            :on-format-error="handleFormatError"
            :on-success="handleSuccess"
            :show-upload-list="false">
      <div style="padding: 20px 0" v-if="dragDrop">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>Click or drag files here to upload</p>
      </div>
      <Button type="primary" v-else icon="ios-cloud-upload" :loading="uploading" :disabled="disabled || disableUpload">
        Select file
      </Button>
    </Upload>
  </div>
</template>

<script>
import config from '@/config'
import { getToken } from '@/libs/util'
import { deleteThumbnail } from '@/api/file'

export default {
  name: 'Uploader',
  props: {
    fileValidateCallback: {
      type: Function,
      required: false
    },
    collections: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    fileId: {
      required: false
    },
    data: {
      type: Object,
      required: false
    },
    defaultFileList: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    accept: {
      type: String,
      required: false
    },
    maxNum: {
      type: Number,
      required: false,
      default: 5
    },
    disableUpload: {
      type: Boolean,
      required: false,
      default: false
    },
    dragDrop: {
      type: Boolean,
      required: false,
      default: false
    },
    showUploadList: {
      type: Boolean,
      required: false,
      default: true
    },
    modelType: {
      type: String,
      required: false
    },
    modelId: {
      type: [Number, String],
      required: false
    }
  },
  mounted () {
    this.type = this.dragDrop ? 'drag' : 'select'
    this.uploadedList = this.defaultFileList
    if (this.accept) {
      this.format = _.map(_.split(this.accept, ','), (item) => {
        return _.trim(_.replace(item, '.', ''))
      })
    }

    if (this.maxNum === 1) {
      this.multiple = false
    }
    this.disabled = this.maxNum <= this.uploadedList.length
    this.setTargetUrl()
  },
  watch: {
    fileId: function () {
      this.setTargetUrl()
    },
    defaultFileList: {
      deep: true,
      handler () {
        this.uploadedList = this.defaultFileList
      }
    }
  },
  data () {
    return {
      target: this.$config.baseUrl + '/files/upload',
      headers: {
        Accept: config.http.headers.Accept,
        Authorization: 'Bearer ' + getToken()
      },
      format: [],
      uploadedList: [],
      disabled: false,
      currentFile: null,
      type: 'drag',
      uploading: false,
      imgVisible: false,
      imgSrc: ''
    }
  },
  computed: {
    showUploader () {
      return !this.uploadedList.length > 0
    }
  },
  methods: {
    setTargetUrl () {
      if (this.fileId) {
        this.target = this.$config.baseUrl + '/files/' + this.fileId + '/replace'
      } else {
        this.target = this.$config.baseUrl + '/files/upload'
      }
    },
    handleBeforeUpload (file, fileList) {
      if (!file) {
        return false
      }
      this.uploading = true

      if (fileList && fileList.length >= this.maxNum) {
        this.$Notice.warning('Reach max number of uploads.')
        return false
      }

      if (this.fileValidateCallback && !this.fileValidateCallback(file)) {
        return false
      }

      // iview Upload component will modify File object make it a new _file variable,
      // which is not a js File object, here we use currentFile to store the just
      // loaded one, which can be sent to parent component if they need it.
      this.currentFile = file
    },
    handleFormatError (file, fileList) {
      this.uploading = false
      this.$Notice.error({
        title: this.$t('notice.error'),
        desc: this.$t('Invalid file format. The accepted file extensions are: ' + this.accept)
      })
    },
    handleSuccess (fileManaged, file, fileList) {
      this.$emit('on-success', fileManaged, this.currentFile)
      this.uploading = false
      this.disabled = fileList.length >= this.maxNum
      this.uploadedList.push(fileManaged)
    },
    handleRemove (file) {
      this.$Modal.confirm({
        title: this.$t('title'),
        content: this.$t('confirm.delete_image_info'),
        onOk: () => {
          // this.uploadedList.
          // this.$refs.uploader.fileList.splice([_.findIndex(this.$refs.uploader.fileList, { 'id': file.id })], 1)
          this.$refs.uploader.fileList.splice(this.uploadedList.indexOf(file), 1)
          this.disabled = this.$refs.uploader.fileList.length >= this.maxNum
          deleteThumbnail(this.modelType, this.modelId, file.id).then((resp) => {
            if (resp.status === 200) {
              this.uploadedList.splice(this.uploadedList.indexOf(file), 1)
              this.$Message.info('File has been removed successfully.')
              this.$emit('on-remove', file)
            }
          })
        },
        onCancel: () => {}
      })
    },
    handleImgPreview (url) {
      this.imgVisible = true
      this.imgSrc = url
    }
  }
}
</script>

<style lang="less" scoped>
  .file-managed-list {
    margin-bottom: 25px;
    font-size: 120%;

    i.ivu-icon {
      margin-right: 5px;
    }
  }
</style>
